/**
 * _backstretch.js
 * @author      Marc-André Appel <marc-andre@sudimage.fr>
 * @copyright   2017 Sudimage Communication
 * @license     http://opensource.org/licenses/MIT MIT
 * @link        https://www.sudimage.fr
 * @created     02/06/2017
 */
// @flow

(() => {
    "use strict";

    const initializeBackstretch = () => {
        if ($window.width() >= 718) {
            if (typeof BACKSTRETCH_IMAGES !== 'undefined') {
                $backstretchContainer
                    .backstretch(BACKSTRETCH_IMAGES, {
                        fade: backstretchFade
                    });
                $html.addClass('backstretch-modified');
            }
        }
    };

    if ( ! CCM_EDIT_MODE) {
        if (window.isNotMobile) {
            $document.ready(() => {
                initializeBackstretch();
            });
        }
    }
})($window, $document, $backstretchContainer, backstretchFade, $navigation);